import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import { props as viewerPropsMapper } from './Rive.mapper';

const props = composeMapper<PreviewWrapperProps<any>, any>()(
  viewerPropsMapper,
  { add: ['isPlayingAllowed', 'componentViewMode'] },
  (resolver, dependencies, carmiData) => {
    const { isPlayingAllowed, componentViewMode } = dependencies;
    const viewerProps = resolver(dependencies, carmiData);
    const isAutoPlayOn = viewerProps.isAutoPlayOn && isPlayingAllowed;

    return {
      ...viewerProps,
      isAutoPlayOn,
      isInPreviewMode: componentViewMode === 'preview',
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
} as any);
